import gql from 'graphql-tag';

export default gql`
  fragment accountGroupAccountFragment on AccountGroupAccount {
    id
  }
`;
